export default "__VITE_ASSET__EWU8I0NV__"